<template>
  <div class="mx-10">
    <v-alert
      outlined
      dismissible
      v-for="error in errors"
      :key="error[0]"
      type="error"
    >
      {{ error[0] }}
    </v-alert>
  </div>
</template>

<script>
export default {
  props: {
    errors: {
      default: []
    }
  }
}
</script>

<style></style>
